export default __webpack_public_path__ + "static/media/no_article_picture.7dbefbfd.svg";